import script from "./FacilitatorView.vue?vue&type=script&setup=true&lang=js"
export * from "./FacilitatorView.vue?vue&type=script&setup=true&lang=js"

import "./FacilitatorView.vue?vue&type=style&index=0&id=d20bf1d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d20bf1d4"]])

export default __exports__